"use strict";

import React from "react";
import _ from "lodash";
import Modal from "../base/Modal.jsx";
import useUserBlogDomains from "../../hooks/query/useUserBlogDomains.js";
import LoadingSpinner from "../LoadingSpinner.jsx";
import SitePublishActions from "../../actions/SitePublishActions.js";
import AppConstants from "../../constants/AppConstants.js";
import { openLoadingTab } from "../../utils/HTMLUtils.js";

const sortBlogs = (a, b) =>
  a.status === AppConstants.BLOG_STATUS_AVAILABLE && b.status !== AppConstants.BLOG_STATUS_AVAILABLE
    ? -1
    : a.status !== AppConstants.BLOG_STATUS_AVAILABLE &&
      b.status === AppConstants.BLOG_STATUS_AVAILABLE
    ? 1
    : 0;

function UserBlogsModal(props) {
  const modalProps = _.pick(props, Modal.BASIC_PROPS);
  const { blogDomains = [], isLoading, isSuccess, isError, error } = useUserBlogDomains();

  const triggerBlogPreview = (blogId) => {
    const newTab = openLoadingTab("Preview is generating...");
    // Popup blocked — no tab to send the preview to, so don't start the request.
    if (newTab) {
      SitePublishActions.generateBlogPreview(blogId, newTab);
    }
    props.onHide();
  };

  return (
    <Modal {...modalProps} verticalPad="6rem" backdrop="static">
      <Modal.Dialog>
        <Modal.Dialog.Header closeButton>
          <Modal.Dialog.Title>My Blogs</Modal.Dialog.Title>
        </Modal.Dialog.Header>
        <Modal.Dialog.Body style={{ padding: 16, minHeight: 500 }}>
          {isLoading && <LoadingSpinner />}
          {isError && <div className="error">{error.message}</div>}
          {isSuccess && (
            <div>
              <p className="instrux" style={{ marginTop: 0 }}>
                Which blog do you want to preview?
              </p>
              <div
                className="si-table"
                style={{
                  borderRadius: "6px",
                }}
              >
                {blogDomains.length > 0 ? (
                  blogDomains.sort(sortBlogs).map((blog) => {
                    const isAvailable = blog.status === AppConstants.BLOG_STATUS_AVAILABLE;
                    return (
                      <div
                        className={`si-table-row${!isAvailable ? " disabled" : ""}`}
                        onClick={() => isAvailable && triggerBlogPreview(blog.wp_host_id)}
                        key={blog.wp_host_id}
                      >
                        <div>{blog.domain_name}</div>
                        {!isAvailable && (
                          <small style={{ marginLeft: ".5rem" }}>not available yet</small>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <p className="instrux" style={{ margin: ".5rem" }}>
                    No blogs found
                  </p>
                )}
              </div>
            </div>
          )}
        </Modal.Dialog.Body>
      </Modal.Dialog>
    </Modal>
  );
}

export default UserBlogsModal;
